module.exports = __webpack_public_path__ + "img/003-whatsapp.5de06485.svg";